const keys = { baseUri: BACK_END_URL };
export { keys };